import type { ServiceKey } from '@/types'

export const PREFILL_EVENT = 'quote:prefill'

let pending: ServiceKey | null = null

/** Remembers which service a call to action was about, so the quote form can pre-select it. */
export const requestPrefill = (service: ServiceKey): void => {
    pending = service

    if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent<ServiceKey>(PREFILL_EVENT, { detail: service }))
    }
}

/** Returns and clears a pre-selection made before the form was on screen. */
export const takePendingPrefill = (): ServiceKey | null => {
    const service = pending

    pending = null

    return service
}
